/**
 * Request-scoped organization workspace id for API interceptors.
 * Kept separate from the Zustand store to avoid circular imports with api.ts.
 */

let currentOrganizationId: string | null = null;

export function setRequestOrganizationId(id: string | null): void {
  currentOrganizationId = id;
}

export function getRequestOrganizationId(): string | null {
  return currentOrganizationId;
}
